import React, { useContext } from 'react';
import cn from 'classnames';
import ConfigContext from '../../../contexts/ConfigContext';

import CtaImage from './CtaImage';

import styles from '../../../../stylesheets/public/layouts/AboutPage.module.postcss';

function TripleCta({ cuisine, optionsText, image }) {
  const { vehicle_type } = useContext(ConfigContext);
  const vehicleType = vehicle_type.toLowerCase();

  return (
    <section className='Section GrayBg'>
      <div className={cn(styles.Cta, styles.Cta__list)}>
        { image && <CtaImage image={image} isResponsive /> }
        <div className={styles.Cta_copy}>
          <div>
            <h3>Compare {cuisine} food {vehicleType}s</h3>
            <ul>
              <li>Requesting quotes is free.</li>
              <li>See menus and pricing from available {cuisine} food {vehicleType}s before you choose.</li>
              <li>{optionsText}</li>
            </ul>
          </div>
          <div>
            <h3>Talk to the {vehicleType}s directly</h3>
            <ul>
              <li>Message {vehicleType}s about menus, timing, and setup.</li>
              <li>Keep event details editable while you compare options.</li>
              <li>Message Support if you have a question.</li>
            </ul>
          </div>
          <div>
            <h3>Book with no surprises</h3>
            <ul>
              <li>See the full price, including fees, before you book.</li>
              <li>Pay on the site once you&#39;ve chosen a {vehicleType}.</li>
              <li>Your quotes, messages, and booking details stay in one place.</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TripleCta;
